import React from 'react'

import { compose, withStateHandlers, defaultProps, branch, renderComponent } from 'recompose'
import { withNamespaces } from 'react-i18next'

import { makeStyles } from '@material-ui/core/styles'
import MuiHelpIcon from '@material-ui/icons/Help'
import MuiInfoIcon from '@material-ui/icons/Info'
import MuiWarningIcon from '@material-ui/icons/Error'
import MuiAlertIcon from '@material-ui/icons/Warning'
import MuiIconButton from '@material-ui/core/IconButton'
import MuiTooltip from '@material-ui/core/Tooltip'
import MuiClickAwayListener from '@material-ui/core/ClickAwayListener'
import theme from 'app/theme'

const useStyles = props => {
  const maxWidthStyle = props.maxWidth ? { maxWidth: `${props.maxWidth}px` } : {}
  return makeStyles(theme => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: props.color ? props.color : theme.palette.primary.main,
      fontSize: 11,
      boxShadow: '0px 0px 2px 1px rgba(0,0,0,0.1)',
      ...maxWidthStyle
    },
    root: {
      padding: props.padding || 0,
      '@media print': {
        display: 'none'
      },
      color: props.color ? props.color : theme.palette.primary.main
    }
  }))
}

const getIconType = {
  info: () => <MuiInfoIcon />,
  help: () => <MuiHelpIcon />,
  warn: () => <MuiWarningIcon color="error" />,
  alert: iconColor => <MuiAlertIcon style={{ color: iconColor ? iconColor : theme.palette.orange.middle }} />
}

const HoverTooltip = ({ placement, iconType = 'help', title, maxWidth, padding, buttonSize, iconColor }) => {
  const classes = useStyles({ maxWidth, padding })()

  return (
    <MuiTooltip classes={{ tooltip: classes.tooltip }} placement={placement} title={title}>
      <MuiIconButton color="primary" size={buttonSize} classes={{ root: classes.root }}>
        {getIconType[iconType](iconColor)}
      </MuiIconButton>
    </MuiTooltip>
  )
}

const ClickableTooltip = ({
  closeToolTip,
  handleTooltipOpen,
  title,
  openToolTip,
  placement,
  iconType = 'help',
  maxWidth,
  padding,
  color,
  buttonSize,
  iconColor,
  ...props
}) => {
  const classes = useStyles({ maxWidth, padding, color })()
  return (
    <MuiClickAwayListener onClickAway={closeToolTip}>
      <MuiTooltip
        classes={{ tooltip: classes.tooltip }}
        onClose={closeToolTip}
        open={handleTooltipOpen}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        placement={placement}
        title={title}
        {...props}
      >
        <MuiIconButton onClick={openToolTip} classes={{ root: classes.root }} size={buttonSize}>
          {getIconType[iconType](iconColor)}
        </MuiIconButton>
      </MuiTooltip>
    </MuiClickAwayListener>
  )
}

const IconHelpToolTip = ({ children }) => <>{children}</>

const enhance = compose(
  withNamespaces('translation'),
  defaultProps({
    showOnHover: false
  }),
  withStateHandlers(
    () => ({
      handleTooltipOpen: false
    }),
    {
      openToolTip: ({ handleTooltipOpen }) => () => ({ handleTooltipOpen: !handleTooltipOpen }),
      closeToolTip: () => () => ({ handleTooltipOpen: false })
    }
  ),
  branch(({ showOnHover }) => showOnHover, renderComponent(HoverTooltip), renderComponent(ClickableTooltip))
)

export default enhance(IconHelpToolTip)
